import fetch from './fetch'

export default {
  getAuthUser (payload) {
    let request = fetch({
      url: `/auth/user`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  resetPassword (payload) {
    if (!payload.password || !payload.passwordResetToken) {
      // TO DO - Return error, raise notification
      return false
    }

    payload = _.pick(payload, [ 'password', 'passwordResetToken' ])

    let request = fetch({
      url: `/auth/reset-password`,
      method: 'post',
      data: payload
    })

    return request.call()
  },

  getUserEmailByPasswordResetToken (payload) {
    if (!payload.passwordResetToken) {
      return false
    }

    const request = fetch({
      url: '/auth/user-email-by-token',
      method: 'get',
      payload: {
        passwordResetToken: payload.passwordResetToken
      }
    })

    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js